The input parameter for the `updatePositionProfileFromDraft` mutation.
